import { useStoreMap } from 'effector-react'
import { rentalContractModel } from '~/entities/RentalContract'
import { pushFx } from '~/shared/lib/history'
import { Block, BlockTitle, BlockDescription } from './styled'

export function WorkScheduleButton() {
  const rentalContract = useStoreMap(
    rentalContractModel.$rentalContract,
    (rentalContract) => rentalContract?.getAttributes(),
  )

  const handleClick = () => {
    pushFx('/work-schedule')
  }

  return (
    <Block onClick={handleClick}>
      <BlockTitle>График</BlockTitle>
      <BlockDescription data-testid='main-car-work-schedule'>
        {rentalContract?.workSchedule}
      </BlockDescription>
    </Block>
  )
}
